<template>
	<div>
		<div class="row">
			<div class="col s12 m8 l10 xl10">
				<div class="row">
					<div class="input-field col s12">
						<i class="material-icons prefix ">search</i>
						<input id="search" type="text" class="validate" v-model="filterTerm">
						<label for="search">Pesquisar</label>
					</div>
				</div>
			</div>
		</div>
		
		<div class="row">
			<div class="col s12 m12 l12 xl12">
				<table>
					<col width="5%">
					<col width="85%">
					<col width="5%">
					<col width="5%">
					<thead>
						<tr>
							<th>#
								<a class="left" href="#" @click="toggleOrder($event, 'id')">
									<i class="material-icons" v-bind:class="{ 'red-text': sortPropertyId }" >sort</i>
								</a>
							</th>
							<th>
								Ação
								<a class="left" href="#" @click="toggleOrder($event, 'titulo')">
									<i class="material-icons" v-bind:class="{ 'red-text': sortPropertyProjeto }" >sort</i>
								</a>
							</th>
							<th>
								Pertinente?
							</th>
							<th v-if='todos'>
								Tem parecer?
							</th>
							<th v-else>
								Habilitado?
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(projeto, index) in filteredProjetos">
							<td>{{index + 1}}</td>
							<td>
								<a :href="'/pertinencia-' + (todos? 'com/' : 'ind/') + projeto.id">
									{{projeto.titulo}}
								</a>
							</td>
							<td>
								<label v-if='projeto.pertinente === true' class="waves-light btn left cyan darken-1"><i class="material-icons">check</i></label>
								<label v-if='projeto.pertinente === false' class="waves-light btn red left"><i class="material-icons">clear</i></label>
							</td>
							<td v-if='todos'>
								<label v-if='projeto.parecer' class="waves-light btn left cyan darken-1"><i class="material-icons">check</i></label>
								<label v-else class="waves-light btn red left"><i class="material-icons">clear</i></label>
							</td>
							<td v-else>
								<label v-if='projeto.impedido' class="waves-light btn red left darken-1"><i class="material-icons">clear</i></label>
								<label v-else class="waves-light btn left cyan"><i class="material-icons">check</i></label>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
			
	</div>
</template>

<script>
    export default {
		name: "VuePertinenciaAvalList",
		props: [
			'projetos',
			'impedido',
			'todos',
		],
		data () {
			return {
				listaProjetos: JSON.parse(this.projetos),
				sortDirection: 'asc',
				filterTerm: '',
				sortProperty: 'id',
				sortPropertyId: true,
				sortPropertyProjeto: false
			}
		},
		computed: {
			filteredProjetos: function () {
				var self = this
				return _.orderBy(self.listaProjetos.filter(function (projeto) {
					var searchRegex = new RegExp(self.filterTerm, 'i')
					return (
						searchRegex.test(projeto.titulo) 
					)
				}), this.sortProperty, this.sortDirection)
			},
		},
		methods: {
			toggleOrder(ev, field) {
				ev.preventDefault()
				if (this.sortProperty == field) {
					if (this.sortDirection == 'asc')
						this.sortDirection = 'desc'
					else
						this.sortDirection = 'asc'
				} else {
					this.iconsColor(this.sortProperty, false)
					this.iconsColor(field, true)
					this.sortProperty = field
					this.sortDirection = 'asc'
				}
			},
			iconsColor(field, value) {
				switch (field) {
					case 'id':
					  this.sortPropertyId = value
					  break;
					case 'titulo':
					  this.sortPropertyProjeto = value
					  break;
					default:
				}
			}
		}
	}
</script>